import { BASE_URL } from "../constants";
import { KaryawanEntity } from "../entities/KaryawanEntity";
import FetchUtils from "../utils/fetch";

class KaryawanService {
    static async GetAllKaryawan(): Promise<KaryawanEntity[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/karyawans`);
        if (resp.status != 200) { throw resp.message }

        const data: KaryawanEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push(new KaryawanEntity({
                id: resp.data[i].ID,
                id_card: resp.data[i].IDCard,
                ncode: resp.data[i].NCode,
                nama: resp.data[i].Nama,
                departemen: resp.data[i].Departemen,
            }))
        }

        return data;
    }

    static async AddKaryawan(
        data: { ncode: string, id_card: string, nama: string, id_departemen: number }
    ): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/karyawans/add`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data })
            }
        );
        if (resp.status != 200) { throw resp.message }
        return resp;
    }

    static async UpdateKaryawan(
        data: KaryawanEntity, fields: { ncode?: string, id_card?: string, nama?: string, id_departemen?: number }
    ): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/karyawans/update`,
            {
                method: 'PUT',
                body: JSON.stringify({ id: data.id, fields })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async DeleteKaryawan(data: KaryawanEntity): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/karyawans/delete`,
            {
                method: 'DELETE',
                body: JSON.stringify({ id: data.id })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async ImportKaryawan(data: KaryawanEntity[]): Promise<{ message: string }> {
        const request = [];
        for (let i = 0; i < data.length; i++) {
            request.push({
                ncode: data[i].ncode,
                id_card: data[i].id_card,
                nama: data[i].nama,
                departemen: data[i].departemen,
            })
        }

        const resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/karyawans/import`,
            {
                method: 'POST',
                body: JSON.stringify({ batch: request })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }
}

export { KaryawanService };